// extracted by mini-css-extract-plugin
export default {"item":"ProductItem_item__tiPlM","price":"ProductItem_price__5rXlf","actions":"ProductItem_actions__RC2JT"};